import { Printer } from "lucide-react";

export function Logo({ size = "md", showSubtitle = true, showCompany = true }) {
  const scale = {
    sm: "text-base",
    md: "text-xl",
    lg: "text-3xl",
  }[size] || "text-xl";

  const iconSizes = {
    sm: "w-8 h-8",
    md: "w-10 h-10",
    lg: "w-14 h-14",
  }[size] || "w-10 h-10";

  return (
    <div className="flex items-center gap-3 select-none" data-testid="printq-logo">
      <div className="relative group">
        <div className="absolute -inset-0.5 rounded-xl bg-gradient-to-r from-amber-400 via-amber-500 to-emerald-500 opacity-60 group-hover:opacity-100 blur-sm transition duration-300" />
        <div className={`relative ${iconSizes} rounded-xl bg-zinc-950 border border-zinc-800 flex items-center justify-center text-amber-400 shadow-xl`}>
          <Printer className="w-1/2 h-1/2 stroke-[2.2]" />
        </div>
        <div className="absolute -bottom-0.5 -right-0.5 w-3 h-3 rounded-full bg-emerald-400 border-2 border-zinc-950 shadow-sm" />
      </div>

      <div className="leading-tight">
        <div className={`font-heading font-extrabold ${scale} tracking-tight whitespace-nowrap flex items-center gap-1`}>
          <span className="text-white">Print</span>
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-400 to-amber-500 font-black">
            Q
          </span>
        </div>

        {showSubtitle && (
          <div className="text-[10px] font-semibold tracking-[0.18em] uppercase text-zinc-400">
            Scan. Enhance. Print.
          </div>
        )}

        {showCompany && (
          <div className="text-[8px] font-medium tracking-[0.15em] uppercase text-zinc-500 mt-0.5">
            by JSM DIGITAL SOLUTIONS
          </div>
        )}
      </div>
    </div>
  );
}